import { defineMessages } from 'react-intl';
const prefix = 'app.commonUtils.capUiLibrary.CapVerticalGroupTable';

export default defineMessages({
  noDataFound: {
    id: `${prefix}.noDataFound`,
    defaultMessage: 'No data found',
  },
});
